import React              from 'react';
import * as PropTypes     from 'prop-types';
import { RenderCheckbox } from './RenderCheckbox';

const RenderCheckboxGroup = ({ ...props }) => {
  const {
          data,
          facets,
          selectedValues,
          onChange,
        } = props;

  // facets: offers left if the value is picked; a picked value stays enabled to be unpicked.
  // The values that lead nowhere go to the end (the order inside both groups is kept).
  const items = Object.values(data).map((btn) => {
    const checked = selectedValues.includes(btn);
    const count   = facets ? (facets[String(btn)] ?? 0) : undefined;

    return { btn, checked, count, disabled: count === 0 && !checked };
  });

  return (
    <div className={'checkbox-group'}>
      {[...items.filter((item) => !item.disabled), ...items.filter((item) => item.disabled)]
        .map(({ btn, checked, count, disabled }) => (
          <RenderCheckbox
            key={String(btn)}
            checked={checked}
            count={count}
            disabled={disabled}
            label={btn.toString()}
            onChange={() => onChange(btn)}
          />
        ))}
    </div>
  );
};

RenderCheckboxGroup.propTypes = {
  checked:  PropTypes.arrayOf(PropTypes.object),
  facets:   PropTypes.objectOf(PropTypes.number),
  label:    PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
export default RenderCheckboxGroup;